export default function DreamRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                        text-align: center;
                    }
                    h2 {
                        font-size: 2rem;
                        text-align: center;
                        color: #0066cc;
                    }
                    h3 {
                        font-size: 25px;
                        color: #0055a5;
                        text-align: left;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }
                    .important {
                        background-color: #ffeeba;
                        border-left: 5px solid #ffc107;
                        padding: 9px;
                        margin: 10px 0;
                        font-weight: bold;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    .modal-body{
                        text-align: left;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px", marginBottom: "10px" }}>
                <div class="modal-dialog modal-lg" role="document" >
                    <div class="modal-content" >
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">


                            <meta charset="UTF-8" />
                            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                            <title>Dream Catcher Casino Game Rules</title>
                            <div class="container" style={{ marginBottom: "40px" }}>
                                <h1><b>Dream Catcher</b></h1>
                                <h2>Rules and Regulations</h2>
                                <hr></hr>

                                <h3><b>GAME OBJECTIVES</b></h3>
                                <p class="pt20">Dream Catcher allows you to play the Money Wheel game of chance that is played using a large vertical wheel, spun by the game host (Dealer).</p>
                                <p class="pt20">The wheel is divided into 54 equal segments separated by pins. 52 segments are marked with a number (1, 2, 5, 10, 20, or 40) with a unique color for each number. If the wheel stops at your chosen number after the spin, you win. The other two segments - 2x multiplier and 7x multiplier - act as bonus spins and multiply your next win!</p>

                                <h3><b>GAME RULES</b></h3>
                                <p class="pt20">Simply place a bet on a number you believe the wheel will stop at: <span class="important">1, 2, 5, 10, 20, or 40.</span> The system will spins the wheel. When it comes to a stop, the winning segment is indicated by the flapper at the top of the wheel.</p>

                                <p class="pt20">All bets are paid on a to one basis with the odds matching the number in the winning segment:</p>
                                <ul class="rules-list">
                                    <li class="important">Winning number 5 pays 5 to 1</li>
                                    <li class="important">Winning number 10 pays 10 to 1</li>
                                </ul>
                                <p class="pt20 important">If the wheel stops on a multiplier segment (2x or 7x), then all bets remain in place and no new bets will be allowed. The wheel is spun again and the outcome of the spin will determine the winning odds as usual but the odds will be multiplied accordingly.</p>
                                <p class="pt20 important">Consecutive multipliers are unlimited subject to a default maximum win according to limits.</p>

                                <h3><b>Betting Instructions</b></h3>
                                <p class="pt20">If a game round is in progress when you enter the game, please wait for the next one, and then place your bets.</p>
                                <p class="pt20">After the timer reaches 0, the game round begins. To place a bet, click on the box, enter the stake amount and submit by clicking on Place Bet button.</p>
                                <p class="pt20">You can place several bets on different runners in different markets simultaneously.</p>
                                <p class="pt20">The timer shows how much time you have left to place your bets. <span class="important">Winnings are paid for the winning bets at the end of each game round.</span> To skip a turn, simply do not place any bets.</p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
